// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"21":"97e0e7a6","107":"3d9b363e","119":"8d71e535","148":"8fe4e524","384":"7e850928","392":"fbaf4b11","598":"60839b1c"}[chunkId] + ".js";
};